import { PrimitiveRole, PrimitiveType, } from "@buildwithflux/models";
import { mat3 } from "../../../common";
import { getConnectedCopperLayers } from "../../layout_engine/helpers/getConnectedCopperLayers";
// TODO: This implementation is currently missing the layout hole and solder mask (and expansion)
// This means that it will work fine for copper DRC but not for rendering or other stuff
export function createShapesForVia(node, stackup) {
    const outerCopperShape = getCopperOuterShape(node);
    const baseHoleShape = getHoleShape(node);
    const copperLayers = getConnectedCopperLayers(node, stackup);
    const transform = node.bakedRules.transformRelativeToShapesLayer ?? mat3.makeIdentity();
    const transformInverse = mat3.invert(transform);
    const copperShapes = copperLayers.map((layer) => ({
        role: PrimitiveRole.copper,
        type: PrimitiveType.Difference,
        primitiveA: { ...outerCopperShape, layerId: layer.uid },
        primitiveB: { ...baseHoleShape, role: PrimitiveRole.copper, layerId: layer.uid },
        layerId: layer.uid,
        transform,
        transformInverse,
    }));
    // Removed since it's inaccurate with microvias
    // const holeShape = {
    //     ...baseHoleShape,
    //     transform: transform.clone().multiply(baseHoleShape.transform),
    //     transformInverse: baseHoleShape.transformInverse.clone().multiply(transformInverse),
    //     layerId: null,
    //     role: ShapeRole.layoutHole,
    // };
    return [
        ...copperShapes,
        //holeShape
    ];
}
function getCopperOuterShape(node) {
    // Will be added by the caller as we need to replicate it for every layer
    const layerId = null;
    // Will be multiplied by the caller, sets only scale
    const scale = node.bakedRules.scale;
    const transform = mat3.makeScale(scale ? scale.x : 1, scale ? scale.y : 1);
    const transformInverse = mat3.invert(transform);
    const isSquare = node.bakedRules.size.x === node.bakedRules.size.y;
    if (isSquare) {
        return {
            role: PrimitiveRole.copper,
            type: PrimitiveType.Circle,
            radius: node.bakedRules.size.x / 2,
            layerId,
            transform,
            transformInverse,
        };
    }
    else {
        return {
            role: PrimitiveRole.copper,
            type: PrimitiveType.Oblong,
            width: node.bakedRules.size.x,
            height: node.bakedRules.size.y,
            layerId,
            transform,
            transformInverse,
        };
    }
}
function getHoleShape(node) {
    const transform = mat3.makeTranslation(node.bakedRules.holePosition?.x ?? 0, node.bakedRules.holePosition?.y ?? 0);
    const transformInverse = mat3.invert(transform);
    const isSquare = node.bakedRules.holeSize.x === node.bakedRules.holeSize.y;
    if (isSquare) {
        return {
            type: PrimitiveType.Circle,
            radius: node.bakedRules.holeSize.x / 2,
            transform,
            transformInverse,
        };
    }
    else {
        return {
            type: PrimitiveType.Oblong,
            width: node.bakedRules.holeSize.x,
            height: node.bakedRules.holeSize.y,
            transform,
            transformInverse,
        };
    }
}
//# sourceMappingURL=createPrimitivesForVia.js.map